<template lang="pug">
    .statement(v-html='content.join("")')
</template>
<script>
export default {
    props: {
        content: Array
    }
};
</script>
<style lang="scss">
.statement {
    width: 100%;
    padding: 0.72em calc(var(--grid-column) * 2) 1.4em;
    background: url(../assets/img/articles/paper-statement.jpg) center / cover no-repeat;
    font-family: var(--font-flow);
    font-family: Flow;
    font-weight: bold;
    font-size: 25px;
    line-height: 2;
    margin-bottom: 40px;
    @media (--viewport-laptop) {
        padding-left: calc(var(--grid-column-laptop) * 2);
        padding-right: calc(var(--grid-column-laptop) * 2);
    }
    @media (--viewport-tablet) {
        padding-left: var(--grid-column-mobile);
        padding-right: var(--grid-column-mobile);
        font-size: 15px;
        margin-bottom: 10px;
    }
}
</style>
